const mapStyles = {
	styles: [
		{
			featureType: 'road',
			elementType: 'geometry',
			stylers: [
				{
					visibility: 'simplified',
				},
				{
					lightness: 100,
				},
			],
		},
		{
			featureType: 'water',
			elementType: 'geometry',
			stylers: [
				{
					visibility: 'on',
				},
				{
					color: '#C6E2FF',
				},
			],
		},
		{
			featureType: 'poi',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#C5E3BF',
				},
			],
		},
		{
			featureType: 'road',
			elementType: 'geometry.fill',
			stylers: [
				{
					color: '#D1D1B8',
				},
			],
		},
		{
			featureType: 'poi.attraction',
			elementType: 'all',
			stylers: [
				{
					visibility: 'simplified',
				},
			],
		},
		{
			featureType: 'poi.business',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'poi.medical',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'poi.government',
			elementType: 'all',
			stylers: [
				{
					visibility: 'on',
				},
			],
		},
		{
			featureType: 'poi.park',
			elementType: 'all',
			stylers: [
				{
					visibility: 'on',
				},
			],
		},
		{
			featureType: 'poi.place_of_worship',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'poi.school',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'poi.sports_complex',
			elementType: 'all',
			stylers: [
				{
					visibility: 'off',
				},
			],
		},
		{
			featureType: 'administrative.country',
			elementType: 'geometry.stroke',
			stylers: [
				{
					color: '#005F3D',
				},
			],
		},
		{
			featureType: 'administrative.province',
			elementType: 'geometry.stroke',
			stylers: [
				{
					color: '#005F3D',
				},
				{
					hue: '#005F3D',
				},
				{
					saturation: -74,
				},
				{
					lightness: 54,
				},
			],
		},
	],
};

export { mapStyles };
